export default "__VITE_ASSET__CNNZNU4P__"